var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isIcon)?_c('v-btn',{attrs:{"color":"blue","loading":_vm.loading,"dark":"","block":""},on:{"click":_vm.exportToExcel}},[_vm._v(_vm._s(_vm.$t('Export Excel'))+" ")]):_vm._e(),(_vm.isIcon)?_c('v-icon',{attrs:{"loading":_vm.loading,"color":"green"},on:{"click":_vm.exportToExcel}},[_vm._v("mdi-microsoft-excel")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }